export interface Purchase {
  name: string
  city: string
  region: string
}

export const purchases: Purchase[] = [
  { name: 'James Whitfield', city: 'Surrey', region: 'United Kingdom' },
  { name: 'Fiona MacLeod', city: 'St Andrews', region: 'United Kingdom' },
  { name: 'Daniel Hughes', city: 'Manchester', region: 'United Kingdom' },
  { name: 'Ryan Caldwell', city: 'Toronto', region: 'Canada' },
  { name: 'Marc Tremblay', city: 'Montreal', region: 'Canada' },
  { name: 'Sarah Bennett', city: 'Vancouver', region: 'Canada' },
  { name: 'Michael Doyle', city: 'Scottsdale', region: 'United States' },
  { name: 'Brian Kessler', city: 'Orlando', region: 'United States' },
  { name: 'Karen Mitchell', city: 'San Diego', region: 'United States' },
  { name: 'Tom Redmond', city: 'Dallas', region: 'United States' },
  { name: 'Luke Harrington', city: 'Melbourne', region: 'Australia' },
  { name: 'Emma Sullivan', city: 'Gold Coast', region: 'Australia' },
  { name: 'Andrew Pike', city: 'Sydney', region: 'Australia' },
  { name: 'Gavin Reid', city: 'Perth', region: 'Australia' },
]
